<web-settings-breadcrumbs>
    <div class="breadcrumb-icon">
        <a (click)="onReset()">
            <img src="./assets/img/websites/lpc-back-icon.svg" class="first-breadcrumb-icon" alt="lpc-back-icon" />
        </a>
    </div>
    <div class="breadcrumb-text">
        <span>{{ "control_button_settings" | translate }}</span>
    </div>
</web-settings-breadcrumbs>
<div class="panel-options-body overflow-wrapper">
    <div class="form form-with-0-margin">
        <div class="mb-20">
            <web-editor
                class="sp-editor form-control checkbox-textarea"
                [toolbarMenu]="'bold italic link'"
                [content]="label()"
                (changeContent)="saveLabel($event)"
            />
        </div>

        @if (crmContactsVariablesList().length) {
            <div class="form-group mb-20" [class.has-error]="hasCrmVariableError()">
                <label class="control-label">
                    {{ "crm_contact_variable" | translate }}
                </label>

                <select class="form-control" (change)="setCrmVariableData($event)">
                    <option [value]="null" disabled [selected]="crmContactVariable() === null">
                        {{ "control_choose_variable" | translate }}
                    </option>
                    @if (crmContactVariable(); as selected) {
                        <option [value]="selected" [selected]="true">
                            {{ getVariableName(selected) | translate }}
                        </option>
                    }
                    @for (variable of filteredCrmContactsVariables(); track variable.id) {
                        <option [value]="variable.id" [disabled]="isDisabledVariable(variable)">
                            {{ variable.name | translate }}
                        </option>
                    }
                </select>
                @if (hasCrmVariableError()) {
                    <span class="help-block small">
                        {{ "error_crm_contact_or_deal_required" | translate }}
                    </span>
                }
            </div>
        }

        <div class="form-group form-horizontal row">
            <label class="col-sm-9 control-label checkbox-inline">
                {{ "control_required" | translate }}
            </label>
            <div class="col-sm-3 control-switch text-right">
                <sp-switch [active]="required()" (toggleActiveEvent)="toggleRequired($event)" />
            </div>
        </div>
    </div>
</div>

<web-settings-footer (saveEvent)="onSave()" (cancelEvent)="onReset()" />
